module.exports = __webpack_public_path__ + "img/energies.95a43bf6.png";